import verloopModal from '../../../../../../../modules/VerzekeringsInzicht/App/verloopModal.js';
import CheckDocument from './CheckDocument.js';

const werkgeverView = {
	/**
	 * Initializes form function
	 *
	 * @returns {void}
	 */
	init: () => {
		new CheckDocument();
		verloopModal.init();
	},
};

export default werkgeverView;
